import { Typography } from '@material-ui/core';
import * as React from 'react';

export const Dashboard: React.FC = () => {
  return <Typography variant="h6">Welcome to Peking</Typography>;
};
